import { Button } from "@/src/components/buttons";
import {
  closeDialog,
  openConfirmDialog,
  openDialog,
} from "@/src/components/dialogs";
import {
  ExamStep,
  Patient,
  PatientDocument,
  Sample,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getServiceId, getUserId } from "@/src/utils/utils";
import { getStandardConfidentiality } from "../patients/confidentialitiesHook";
import { choseAnapathDocumentTemplate } from "./anapathDocumentsCompartment";
import { openAnapathSampleForm } from "./anapathSampleForm";
import { openExamStepsPicker } from "./examStepsPicker";
import { openMultipleSlicesForm } from "./multipleSlicesForm";
import { openUsersCheckboxList } from "../admin/users/usersHook";
import { UploadSpots } from "@/src/components/uploadSpots";

export default async function openAnapathSampleActions({
  sample,
  patient,
  onChange,
  onDocumentCreate,
  onDocumentValidate,
}: {
  sample: Sample;
  patient: Patient;
  onChange: (newValue: Sample) => void;
  onDocumentCreate: (patientDocument: PatientDocument) => void;
  onDocumentValidate: (patientDocument: PatientDocument) => void;
}) {
  function close() {
    closeDialog("commandActionsDialog");
  }
  return await openDialog({
    id: "commandActionsDialog",
    title: "Actions",
    content: (
      <div className="c1 gap10">
        <Button
          onClick={async () => {
            close();
            await addSampleDocument({
              sample,
              patient,
              onDocumentCreate,
              onDocumentValidate,
              onChange,
            });
          }}
        >
          Ajouter compte rendu
        </Button>
        <Button
          type="tertiary"
          onClick={async () => {
            close();
            await addExamStep({
              sample,
              onChange,
            });
          }}
        >
          Ajouter Etapes
        </Button>

        <Button
          type="tertiary"
          onClick={async () => {
            close();
            openMultipleSlicesForm({
              sample,
              onSave: async (slices) => {
                onChange(sample);
              },
            });
          }}
        >
          Ajouter lames
        </Button>

        <Button
          type="tertiary"
          onClick={async () => {
            await openAnapathSampleForm({
              sample,
              onSave: async (sample) => {
                onChange(sample);
              },
            });
          }}
        >
          Modifier
        </Button>

        <Button
          color="red"
          type={"tertiary"}
          onClick={async () => {
            await openConfirmDialog({
              title: "Supprimer le prélèvement",
              content: "Voulez-vous vraiment supprimer ce prélèvement ?",
              onConfirm: async () => {
                await apiFetch("samples", "deleteOne", {
                  sampleId: getItemId(sample),
                });
                onChange(sample);
                close();
              },
            });
          }}
        >
          Supprimer
        </Button>
      </div>
    ),
  });
}

export async function addSampleDocument({
  sample,
  patient,
  onDocumentCreate,
  onDocumentValidate,
  onChange,
}: {
  sample: Sample;
  patient: Patient;
  onDocumentCreate: (patientDocument: PatientDocument) => void;
  onDocumentValidate: (patientDocument: PatientDocument) => void;
  onChange: (sample: Sample) => void;
}) {
  return await choseAnapathDocumentTemplate({
    parent: sample,
    patient: patient,
    onDocumentCreate: async (patientDocument) => {
      onDocumentCreate(patientDocument);
      onChange(sample);
    },
    onDocumentValidate: async (patientDocument) => {
      onDocumentValidate(patientDocument);
      onChange(sample);
    },
  });
}

export async function addExamStep({
  sample,
  onChange,
}: {
  sample: Sample;
  onChange: (sample: Sample) => void;
}) {
  return await openExamStepsPicker({
    current: [],
    onConfirm: async (newReferences) => {
      await openUsersCheckboxList({
        serviceId: getServiceId(),
        title: "Choisir les utilisateurs",
        selectedUsers: [],
        onConfirm: async (users) => {
          let examSteps: (ExamStep | null | undefined)[] = sample.steps || [];
          for (const reference of newReferences) {
            // const alreadyExists = examSteps.find(
            //   (step) =>
            //     getItemId(step?.reference) === getItemId(reference)
            // );
            // if (alreadyExists) continue;

            examSteps.push({
              type: "examStep",
              status: "pending",
              parent: getItemId(sample),
              patient: getItemId(sample.patient),
              reference: getItemId(reference),
              creator: getUserId(),
              confidentiality: getStandardConfidentiality(sample.patient),
              content: null,
              readBy: [],
              affectedTo: users,
            });
          }
          sample = await apiFetch("samples", "addOne", {
            sample: {
              id: getItemId(sample),
              steps: examSteps,
            } as Sample,
          });
          onChange(sample);
        },
      });
    },
  });
}

export async function addSampleUploads({
  sample,
  patient,
  onChange,
}: {
  sample: Sample;
  patient: Patient;
  onChange: (sample: Sample) => void;
}) {
  await openDialog({
    id: "addSampleFileDialog",
    title: "Ajouter un fichier",
    content: (
      <UploadSpots
        name="Pièces jointes"
        value={sample.uploads}
        gridCount={2}
        spotsCount={2}
        additionalUploadData={{
          patient: getItemId(patient),
        }}
        onChange={(newValue) => {
          sample.uploads = newValue;
        }}
      ></UploadSpots>
    ),
    onConfirm: async () => {
      closeDialog("addSampleFileDialog");
      let newSampleValue = await apiFetch("samples", "addOne", {
        sample: {
          id: getItemId(sample),
          uploads: sample.uploads,
        } as Sample,
      });
      console.log({ newSampleValue });
      onChange({ ...newSampleValue });
    },
  });
}
